import { Component, inject, input, viewChild } from '@angular/core';
import { FilterObject } from '@it2go/data-grid';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import {
    dateField,
    dateTimeField,
    longTextField,
    textColumn,
} from '../../../../shared/components/kit/table/table.fields';
import { TableColumn, TableColumnType } from '../../../../shared/components/kit/table/table.types';
import { router, translate } from '../../../../shared/shared.global-service';
import { messageTypeEnumOptions } from '@libs/types/src/user/enum/message-type.enum';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { contentGlobalSuccess } from '../../../content.error';
import { ProfileMessagesStore } from './profile-messages.store';
import { profileMessagesFrag } from './profile-messages.query';

@Component({
    selector: 'app-profile-messages',
    templateUrl: './profile-messages.component.html',
    providers: [ProfileMessagesStore],
    imports: [
        TableComponent,
    ],
})
export class ProfileMessagesComponent {

    protected readonly store = inject(ProfileMessagesStore);
    protected readonly confirm = inject(ConfirmBuilder);
    
    public isWidget = input<boolean>(false);
    public detailHandler = input<((item: any) => void) | null>(null);

    public additionalFilter = input<FilterObject[][] | null>(null);

    protected readonly table = viewChild<TableComponent>('userProfileMessagesTable');

    protected readonly prefix = 'messages.';

    protected readonly columns: TableColumn[] = [
        textColumn('title'),
        {
            name: 'type',
            data: (item: any) => translate.instant(`enum.messageType.${item}`),
            type: TableColumnType.Tag,
            filterable: {
                selectOptions: () => messageTypeEnumOptions,
            },
        },
        longTextField('content', true, false),
        dateTimeField('createdAt'),
        dateField('validFrom'),
        dateField('validTo'),
        dateTimeField('readAt'),
    ];

    protected readonly transformItem = (item: any) => ({
        ...item,
        ...(item?.message ?? {}),
        id: item.id,
        readAt: item.readAt,
    });

    public detail(item: any): void {
        const handler = this.detailHandler();
        if (handler) {
            handler(item);
            return;
        }
        router.navigate(['/content/profile/msg', item.id]);
    }

    public delete(event: any): void {
        this.confirm.confirmDelete(async () => {
            await this.store.api.deleteMessageRecipient({ id: event.item.id });
            contentGlobalSuccess.next('common.deleted');
            this.table()?.reload();
        }, event);
    }

    protected readonly fragment = profileMessagesFrag;
}
